import { render, staticRenderFns } from "./SubMenuNavbar.vue?vue&type=template&id=5d14f9c5&scoped=true"
import script from "./SubMenuNavbar.vue?vue&type=script&lang=js"
export * from "./SubMenuNavbar.vue?vue&type=script&lang=js"
import style0 from "./SubMenuNavbar.vue?vue&type=style&index=0&id=5d14f9c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d14f9c5",
  null
  
)

export default component.exports